import Vue from 'vue'
// import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import '@/styles/index.less' // global css
import App from './App'
import router from './router'
import store from './store'
//全局加载就可以了
import '@/icons'
import './plugins/element.js'
import './assets/css/global.css'
// import 'lib-flexible/flexible.js'
import dayjs from 'dayjs'
import Share from "vue-social-share";
import 'vue-social-share/dist/client.css';

import '../node_modules/social-share.js/dist/js/social-share.min.js'



import './utils/lang'
// 无缝滚动插件
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
//or you can set componentName default componentName is vue-seamless-scroll
Vue.use(scroll,{componentName: 'scroll-seamless'})
Vue.prototype.L = window.L;
Vue.prototype.L2 = window.L2
Vue.prototype.G = {};


Vue.use(Share);
import Meta from 'vue-meta';
Vue.use(Meta);
// const imgUrl = 'http://192.168.8.215:8000/tsMgz/'
const imgUrl = 'https://ts960.com/tsMgz/'
Vue.prototype.$imgUrl = imgUrl
Vue.prototype.$dayjs = dayjs

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js